import { useMutation } from '@tanstack/react-query';
import { searchTimeSlots } from '@services/cpqService';
import type { TimeSlotSearchRequest, BookingSlotSearchResponse } from '@t/checkout.types';

interface UseSearchBookingSlotsOptions {
  onSuccess?: (data: BookingSlotSearchResponse) => void;
  onError?: (error: Error) => void;
}

export const useSearchBookingSlots = (sessionId: string, { onSuccess, onError }: UseSearchBookingSlotsOptions = {}) => {
  const mutation = useMutation<BookingSlotSearchResponse, Error, TimeSlotSearchRequest>({
    mutationFn: (payload) => searchTimeSlots(sessionId, payload),
    onSuccess,
    onError,
  });

  return {
    searchSlots: mutation.mutate,
    isSearching: mutation.isPending,
    slotsData: mutation.data ?? null,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
};
